import script from "./AddBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddBtn.vue?vue&type=script&lang=ts&setup=true"

import "./AddBtn.vue?vue&type=style&index=0&id=1d32efae&lang=scss&scope=true"

const __exports__ = script;

export default __exports__